<div class="modal-container">
    <a type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </a>
    <div>
        <div class="title" [ngStyle]="{ color: color }">
            {{ familyStatusName }} - {{ statusName }}
        </div>
        <p class="duration">{{ 'time' | lang}}: {{ duration }}</p>
    </div>
    <app-main-table [tableConfig]="tableConfig" class="table-wrapper-scroll-y"></app-main-table>
</div>

